var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5H17.5C17.8315 5 18.1495 5.1317 18.3839 5.36612C18.6183 5.60054 18.75 5.91848 18.75 6.25V16.25C18.75 16.5815 18.6183 16.8995 18.3839 17.1339C18.1495 17.3683 17.8315 17.5 17.5 17.5H2.5C2.16848 17.5 1.85054 17.3683 1.61612 17.1339C1.3817 16.8995 1.25 16.5815 1.25 16.25V3.125C1.25 2.79348 1.3817 2.47554 1.61612 2.24112C1.85054 2.0067 2.16848 1.875 2.5 1.875H16.25V3.125H2.5V5ZM2.5 6.25V16.25H17.5V14.375H12.5C12.1685 14.375 11.8505 14.2433 11.6161 14.0089C11.3817 13.7745 11.25 13.4565 11.25 13.125V9.375C11.25 9.04348 11.3817 8.72554 11.6161 8.49112C11.8505 8.2567 12.1685 8.125 12.5 8.125H17.5V6.25H2.5ZM17.5 13.125V9.375H12.5V13.125H17.5ZM13.75 10.625H15V11.875H13.75V10.625Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.77fcab3b2970a5da2fe20fea4b54c923.svg";
export { ForwardRef as ReactComponent };